import { Button, Form, Input, Row, Typography, Col } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sendUserRecoveryCode } from "../../services/authApi";
import { WebRoutes } from "../../shared/constants/WebRoutes";
import ContainerLayout from "../common/containerLayout";
import "./styles.css";

const { Title } = Typography;

const ForgotPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    const { email } = values;
    setIsLoading(true);

    await sendUserRecoveryCode(email)
      .then(() => {
        navigate(`${WebRoutes.RecoverPasswordRoute}?email=${encodeURIComponent(email)}`);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <ContainerLayout showNotification={false} defaultContainer={false}>
        <Col
          style={{
            height: "94.3vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            overflowY: "hidden",
          }}
        >
      <Row justify="center">
        <Title>Recuperar contraseña</Title>
      </Row>
      <Row justify="center">
        <Typography.Paragraph>
          Ingresa el correo asociado a tu cuenta. Te enviaremos un código para
          restablecer tu contraseña.
        </Typography.Paragraph>
      </Row>
      <Row className="form-container">
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            label="Correo electrónico"
            name="email"
            rules={[
              {
                required: true,
                message: "Por favor ingresa un correo",
              },
              {
                type: "email",
                message: "Por favor ingresa un correo válido",
              },
            ]}
          >
            <Input placeholder="correo@ejemplo.com" />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            className="button-container"
            loading={isLoading}
          >
            Enviar código
          </Button>
          <Button
            type="link"
            onClick={() => navigate(WebRoutes.LoginRoute)}
            style={{ marginTop: 12 }}
          >
            Volver al login
          </Button>
        </Form>
      </Row></Col>
    </ContainerLayout>
  );
};

export default ForgotPassword;
